import { Store } from "@ngrx/store";
import * as fromRoot from "../../reducers";
import { DiagnosisWidgetService } from "../diagnosis/diagnosis-widget.service";
import { PlanTreatmentsService } from "./plan-treatments.service";
import { PriceManagerService } from "./plan-price.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import "rxjs-spy/add/operator/tag";
import { Observable } from "rxjs/Observable";
var PlanWidgetService = /** @class */ (function () {
    function PlanWidgetService(store, diagnosisWidgetService, treatmentsService, priceManagerService) {
        var _this = this;
        this.store = store;
        this.diagnosisWidgetService = diagnosisWidgetService;
        this.treatmentsService = treatmentsService;
        this.priceManagerService = priceManagerService;
        this.valid$ = new BehaviorSubject(false);
        this.validItem$ = new BehaviorSubject(null);
        this.price$ = new BehaviorSubject(0);
        this.planOdontogram$ = new BehaviorSubject(null);
        this.odontogram$ = new BehaviorSubject(null);
        // plan odontogram
        Observable.combineLatest(diagnosisWidgetService
            .getOdontogram()
            .distinctUntilChanged()
            .tag("plan/getOdontogram"), store.select(fromRoot.getPlanItems).tag("plan/getPlanItems"))
            .map(function (_a) {
            var diagnosisOdontogram = _a[0], planItems = _a[1];
            return _this.computeOdontogram(diagnosisOdontogram, planItems);
        })
            .tag("plan/planOdontogram$")
            .subscribe(this.planOdontogram$);
        // valid
        store
            .select(fromRoot.getPlanCurrentItemFull)
            .tag("plan/getPlanCurrentItemFull")
            .withLatestFrom(this.planOdontogram$)
            .map(function (_a) {
            var currentItem = _a[0], odontogram = _a[1];
            return [
                currentItem,
                _this.checkIfValid(odontogram, currentItem),
            ];
        })
            .tag("plan/valid$")
            .do(function (_a) {
            var currentItem = _a[0], valid = _a[1];
            _this.valid$.next(valid);
            if (!valid) {
                _this.validItem$.next(null);
                _this.price$.next(null);
            }
        })
            .filter(function (_a) {
            var currentItem = _a[0], valid = _a[1];
            return valid;
        })
            .map(function (_a) {
            var currentItem = _a[0];
            return currentItem;
        })
            .tag("plan/validItem$")
            .subscribe(this.validItem$);
        // price
        this.validItem$
            .filter(Boolean)
            .flatMap(function (item) { return _this.priceManagerService.computePrice(item); })
            .tag("plan/price$")
            .subscribe(function (price) { return _this.price$.next(price); });
        // final odontogram
        Observable.combineLatest(this.planOdontogram$, this.validItem$)
            .map(function (_a) {
            var odontogram = _a[0], item = _a[1];
            return _this.computeOdontogram(odontogram, item ? [item] : []);
        })
            .tag("plan/odontogram$")
            .subscribe(this.odontogram$);
    }
    PlanWidgetService.prototype.computeOdontogram = function (odontogram, items) {
        var _this = this;
        // create a copy of odontogram
        var updatedOdontogram = [];
        odontogram.forEach(function (x) {
            var copy = Object.assign({}, x);
            copy.plan = x.plan.slice();
            updatedOdontogram.push(copy);
        });
        items.forEach(function (item) {
            // console.log('applying', item);
            var treatmentClass = _this.treatmentsService.getClassForTreatment(item.treatment);
            if (treatmentClass) {
                treatmentClass.apply(updatedOdontogram, item);
            }
            else {
                console.log("treatment not supported", item.treatment);
            }
        });
        // console.log('finished plan apply');
        return updatedOdontogram;
    };
    PlanWidgetService.prototype.checkIfValid = function (odontogram, currentItem) {
        // no treatment selected, so the item is not valid
        if (!currentItem.treatment) {
            return false;
        }
        var treatmentClass = this.treatmentsService.getClassForTreatment(currentItem.treatment);
        // if given treatment is supported
        if (treatmentClass) {
            return treatmentClass.validate(currentItem, odontogram, []);
        }
        else {
            console.log("treatment not supported", currentItem.treatment);
        }
        return false;
    };
    PlanWidgetService.prototype.getOdontogram = function () {
        return this.odontogram$;
    };
    PlanWidgetService.prototype.isValid = function () {
        return this.valid$;
    };
    PlanWidgetService.prototype.getPrice = function () {
        return this.price$;
    };
    return PlanWidgetService;
}());
export { PlanWidgetService };



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/plan-widget.service.ts.pre-build-optimizer.js